import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "seals_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => { localStorage.setItem(KEY, "accepted"); setShow(false); };

  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[60] fade-up">
      <div className="backdrop-blur-xl bg-black/90 border border-[#22d3ee]/40 clip-hud p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <Cookie className="w-6 h-6 text-[#67e8f9] shrink-0 mt-0.5" />
          <div>
            <p className="font-rajdhani text-gray-200 text-sm leading-relaxed">
              Usiamo solo cookie tecnici necessari al funzionamento del sito. Nessun tracciamento pubblicitario.
              Consulta la <Link to="/cookie-policy" data-testid="cookie-banner-link" className="text-[#67e8f9] underline hover:text-white">Cookie Policy</Link>.
            </p>
            <div className="flex gap-2 mt-3">
              <button data-testid="cookie-accept-btn" onClick={accept} className="btn-cyber clip-hud px-5 py-1.5 text-xs">Ho capito</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
